import type { LeadFlowDocument, LeadFlowQuestionStyle } from "../types";

const DEFAULT_QUESTION_STYLE: LeadFlowQuestionStyle = {
  multiSelectFormat: "checkbox-card",
};

/**
 * Reads the flow's question style. Documents saved before a setting existed
 * have no value for it, so each falls back to Studio's initial value.
 */
function getQuestionStyle(leadFlow: LeadFlowDocument): LeadFlowQuestionStyle {
  const questionStyle = leadFlow.presentation?.questionStyle;

  return {
    multiSelectFormat:
      questionStyle?.multiSelectFormat ??
      DEFAULT_QUESTION_STYLE.multiSelectFormat,
  };
}

export { DEFAULT_QUESTION_STYLE, getQuestionStyle };
